// Module
var code = "<span> {{vm.displayName | uppercase}} </span>";
// Exports
module.exports = code;